<main class="legal-page" role="main">
  <div class="legal-page-column">
    <h1 id="cancellation-policy-title" class="legal-page-title">{{ 'LEGAL.TITLE.CANCELLATION-POLICY' | translate }}</h1>
    <article class="legal-card" aria-labelledby="cancellation-policy-title">
      @switch (((brandingData$ | async)?.legalCancellationPolicy)) {
        @case ('agaplesion-CP') {
          <app-cancellation-policy-agaplesion></app-cancellation-policy-agaplesion>
        }
        @default {
          <app-cancellation-policy-patientus></app-cancellation-policy-patientus>
        }
      }
    </article>
  </div>
</main>
